import { useFlags } from 'launchdarkly-react-client-sdk'
import { useIsLDReadyForUser } from 'mednet-cns/src/hooks/launchDarkly'

export default function useHomePath() {
  const isLdReady = useIsLDReadyForUser()
  const { enableV2FeedPage } = useFlags()

  const homePath = enableV2FeedPage ? '/v2/feed' : '/home/index'

  return {
    homePath,
    isLdReady,
  }
}
